import { Dispatch, SetStateAction } from "react"

import { EMPTY_ERROR } from "modules/NewClientSurvey/components/Question/constants"
import { checkValue } from "modules/NewClientSurvey/components/Question/helpers/checkValue"
import { SurveyAnswer, SurveyQuestion, ValueErrorType } from "modules/NewClientSurvey/common"

export function checkQuestionValue(
    question: SurveyQuestion,
    inputValue: SurveyAnswer,
    changeError: Dispatch<SetStateAction<string | undefined>>
) {
    const { validations } = question
    const valueError = checkValue(question, inputValue)

    switch (valueError) {
        case ValueErrorType.Empty:
            changeError(EMPTY_ERROR)
            return false
        case ValueErrorType.LessThanRequired:
            changeError(`Минимальное значение ${validations.min_value}`)
            return false
        case ValueErrorType.MoreThanRequired:
            changeError(`Максимальное значение ${validations.max_value}`)
            return false
        case ValueErrorType.ShorterThanRequired:
            changeError(`Минимальная длина ${validations.min_length}`)
            return false
        case ValueErrorType.LongerThanRequired:
            changeError(`Максимальная длина ${validations.max_length}`)
            return false
        case ValueErrorType.FewerThanRequired:
            changeError(`Минимальное количество ответов ${validations.min_length}`)
            return false
        case ValueErrorType.ExceedsAllowedCount:
            changeError(`Максимальное количество ответов ${validations.max_length}`)
            return false
        default:
            break
    }

    return true
}
